export const AGGREGATE_DAILY_CONTAINER_BOOKING_JD_TEAM = [
  {
    id: "expander",
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        <i
          className={
            isAllRowsExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
          }
        ></i>
      </span>
    ),
    Cell: ({ row }) =>
      row.canExpand ? (
        <span {...row.getToggleRowExpandedProps()}>
          <i
            className={
              row.isExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
            }
          ></i>
        </span>
      ) : null,
  },
  {
    Header: "UPLOAD DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "COUNTRY",
    accessor: "Country",
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNumber",
  },
  {
    Header: "CATEGORY",
    accessor: "Category",
  },
  {
    Header: "SUB CATEGORY",
    accessor: "SubCategory",
  },
  {
    Header: "QUANTITY",
    accessor: "Quantity",
  },
  {
    Header: "CONTAINER COUNT",
    accessor: "Container_Count",
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
  },
  {
    Header: "REMARK",
    accessor: "Remark",
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
  {
    Header: "BOOKING NUMBER",
    accessor: "Booking_Number",
  },
  {
    Header: "BOOKING DOC",
    accessor: "Booking_Doc",
  },
  {
    Header: "REASON",
    accessor: "Reason",
  },
  {
    Header: "HOLD REASON",
    accessor: "HoldReason",
    width : 1
  },
  {
    Header: "STATUS",
    accessor: "STATUS",
  },
  {
    Header: "VSL/VOY",
    accessor: "VSL_VOY",
    width : 900
  },
  {
    Header: "ETD",
    accessor: "ETD",
  },
  {
    Header: "ETA",
    accessor: "ETA",
  },
  {
    Header: "PORT OF DESTINATION",
    accessor: "Port_Of_Destination"
  },
  {
    Header: "FINAL DESTINATION",
    accessor: "final_destination",
    width : 900
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
  },
  {
    Header: "INSPECTION",
    accessor: "Inspection"
  },
  {
    Header: "GROUND RENT DAYS",
    accessor: "Ground_Rent_Days",
  },
  {
    Header: "ORIGIN TRANSIT TIME",
    accessor: "Origin_Transit_Time",
  },
  {
    Header: "APPROX CONTAINER DETENTION",
    accessor: "Approx_container_detention",
  },
  {
    Header: "HOLD",
    accessor: "Holdtoggle",
    width : 1
  },
  {
    Header: "ACTION",
    accessor: "action",
  },
];

export const AGGREGATE_DAILY_CONTAINER_BOOKING_PUNE_TEAM = [
  {
    id: "expander",
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        <i
          className={
            isAllRowsExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
          }
        ></i>
      </span>
    ),
    Cell: ({ row }) =>
      row.canExpand ? (
        <span {...row.getToggleRowExpandedProps()}>
          <i
            className={
              row.isExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
            }
          ></i>
        </span>
      ) : null,
  },
  {
    Header: "UPLOAD DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "COUNTRY",
    accessor: "Country",
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNumber",
  },
  {
    Header: "CATEGORY",
    accessor: "Category",
  },
  {
    Header: "SUB CATEGORY",
    accessor: "SubCategory",
  },
  {
    Header: "QUANTITY",
    accessor: "Quantity",
  },
  {
    Header: "CONTAINER COUNT",
    accessor: "Container_Count",
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
  },
  {
    Header: "REMARK",
    accessor: "Remark",
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
  {
    Header: "BOOKING NUMBER",
    accessor: "Booking_Number",
  },
  {
    Header: "BOOKING DOC",
    accessor: "Booking_Doc",
  },
  {
    Header: "REASON",
    accessor: "Reason",
  },
  {
    Header: "HOLD REASON",
    accessor: "HoldReason",
    width : 1
  },
  {
    Header: "STATUS",
    accessor: "STATUS",
  },
  {
    Header: "VSL/VOY",
    accessor: "VSL_VOY",
    width : 900
  },
  {
    Header: "ETD",
    accessor: "ETD",
  },
  {
    Header: "ETA",
    accessor: "ETA",
  },
  {
    Header: "PORT OF DESTINATION",
    accessor: "Port_Of_Destination"
  },
  {
    Header: "FINAL DESTINATION",
    accessor: "final_destination",
    width : 900
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
  },
  {
    Header: "INSPECTION",
    accessor: "Inspection"
  },
  {
    Header: "GROUND RENT DAYS",
    accessor: "Ground_Rent_Days",
  },
  {
    Header: "ORIGIN TRANSIT TIME",
    accessor: "Origin_Transit_Time",
  },
  {
    Header: "APPROX CONTAINER DETENTION",
    accessor: "Approx_container_detention",
  },
  {
    Header: "HOLD",
    accessor: "Holdtoggle",
    width : 1
  },
];

export const AGGREGATE_DAILY_CONTAINER_BOOKING_PUNE_TEAM_WITH_DELETE = [
  {
    id: "expander",
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        <i
          className={
            isAllRowsExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
          }
        ></i>
      </span>
    ),
    Cell: ({ row }) =>
      row.canExpand ? (
        <span {...row.getToggleRowExpandedProps()}>
          <i
            className={
              row.isExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
            }
          ></i>
        </span>
      ) : null,
  },
  {
    Header: "ADD",
    accessor: "Add",
    width : 60
  },
  {
    Header: "OFP PLAN DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "COUNTRY",
    accessor: "Country",
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNumber",
  },
  {
    Header: "CATEGORY",
    accessor: "Category",
  },
  {
    Header: "SUB CATEGORY",
    accessor: "SubCategory",
  },
  {
    Header: "QUANTITY",
    accessor: "Quantity",
  },
  {
    Header: "CONTAINER COUNT",
    accessor: "Container_Count",
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
  },
  {
    Header: "REMARK",
    accessor: "Remark",
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
  {
    Header: "BOOKING NUMBER",
    accessor: "Booking_Number",
  },
  {
    Header: "BOOKING DOC",
    accessor: "Booking_Doc",
  },
  {
    Header: "REASON",
    accessor: "Reason",
  },
  {
    Header: "HOLD REASON",
    accessor: "HoldReason",
    width : 1
  },
  {
    Header: "STATUS",
    accessor: "STATUS",
  },
  {
    Header: "VSL/VOY",
    accessor: "VSL_VOY",
    width : 900
  },
  {
    Header: "ETD",
    accessor: "ETD",
  },
  {
    Header: "ETA",
    accessor: "ETA",
  },
  {
    Header: "PORT OF DESTINATION",
    accessor: "Port_Of_Destination"
  },
  {
    Header: "FINAL DESTINATION",
    accessor: "final_destination",
    width : 900
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
  },
  {
    Header: "INSPECTION",
    accessor: "Inspection"
  },
  {
    Header: "GROUND RENT DAYS",
    accessor: "Ground_Rent_Days",
  },
  {
    Header: "ORIGIN TRANSIT TIME",
    accessor: "Origin_Transit_Time",
  },
  {
    Header: "APPROX CONTAINER DETENTION",
    accessor: "Approx_container_detention",
  },
  {
    Header: "HOLD",
    accessor: "Holdtoggle",
    width : 1
  },
  // {
  //   Header: "DELETE",
  //   accessor: "Delete",
  // },
];

export const COUNTRY_WISE_WEEKLY_PLAN = [
  {
    Header: "COUNTRY",
    accessor: "Country",
  },
  {
    Header: "PLANNING MONTH",
    accessor: "PlanningMonth",
  },
  {
    Header: "WEEK 1",
    accessor: "W1",
  },
  {
    Header: "WEEK 2",
    accessor: "W2",
  },
  {
    Header: "WEEK 3",
    accessor: "W3",
  },
  {
    Header: "WEEK 4",
    accessor: "W4",
  },
  {
    Header: "WEEK 5",
    accessor: "W5",
  },
  {
    Header: "TOTAL",
    accessor: "TotalMonth",
  },
];

export const CONTAINER_TYPE_WISE_WEEKLY_PLAN = [
  {
    Header: "CONTAINER TYPE",
    accessor: "ContainerType",
  },
  {
    Header: "PLANNING MONTH",
    accessor: "PlanningMonth",
  },
  {
    Header: "WEEK 1",
    accessor: "W1",
  },
  {
    Header: "WEEK 2",
    accessor: "W2",
  },
  {
    Header: "WEEK 3",
    accessor: "W3",
  },
  {
    Header: "WEEK 4",
    accessor: "W4",
  },
  {
    Header: "WEEK 5",
    accessor: "W5",
  },
  {
    Header: "TOTAL",
    accessor: "TotalMonth",
  },
];
